import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button, Collapse, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useState } from "react";
import { updateTax, validGSTNumber } from "./client_halper";

function TaxEdit({ client, onChange }) {
    const [inputErrors, setInputErrors] = useState({});
    const [expanded, setExpanded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const gst_num = data.get("gst_num");
        const scheme = data.get("pickup_scheme");
        const charge = Number(data.get("pickup_charge"));
        const quotation = data.get("quotation");
        const fuel_charge = Number(data.get("fuel_charge"));
        var flag = true;
        if (__error_handler(validGSTNumber(gst_num), "gst_num", "You have not entered a valid GST number.")) {
            flag = false;
        }
        if (flag) {
            const _json = {
                "gst": gst_num, "pickup_scheme": scheme, "pickup_charge": charge,
                "fuel_charge": fuel_charge, "quotation": quotation, "client": client.client_id
            };
            updateTax(_json).then((_) => {
                _json["gst_num"] = gst_num;
                delete _json["gst"];
                delete _json["auth"];
                onChange({ status: "loaded", message: "change", change: _json });
                setIsLoading(false);
            }).catch((err) => {
                onChange({ status: "loaded", message: "failed", error: err.message });
                setIsLoading(false);
            });
        } else {
            onChange({ status: "loaded", message: "validation_error" });
            setIsLoading(false);
        }
    }

    const validateInputs = (event) => {
        onChange({ status: "loading" });
        return true;
    }

    return (
        <Box>
            <Button style={{ textTransform: "none" }} onClick={() => { setExpanded(!expanded); }}>
                {expanded ? <ExpandMore /> : <ExpandLess />} Tax and Charges
            </Button>
            <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ mt: 1 }}>
                <Grid container spacing={2} component="form" onSubmit={handleSubmit} noValidate>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="gst_num" defaultValue={client.gst_num} fullWidth error={inputErrors.gst_num} type="text" helperText={inputErrors.gst_num} placeholder="Ex 27AAAPA1234A1Z5" label="GST Number" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <FormControl fullWidth>
                            <InputLabel id="pickup-scheme">Pickup Scheme</InputLabel>
                            <Select
                                labelId="pickup-scheme"
                                id="pickup-scheme"
                                name="pickup_scheme"
                                error={inputErrors.pickup_scheme}
                                helperText={inputErrors.pickup_scheme}
                                placeholder="pickup_scheme"
                                label="Pickup Scheme"
                                defaultValue={client.pickup_scheme}
                            >
                                <MenuItem value={null} selected>None</MenuItem>
                                {["PER_PICKUP", "FIXED", "PERCENTAGE"].map((item) => <MenuItem value={item} key={item}>{item}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="pickup_charge" defaultValue={client.pickup_charge} fullWidth error={inputErrors.pickup_charge} type="text" helperText={inputErrors.pickup_charge} placeholder="Pickup Charge" label="Pickup Charge" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="fuel_charge" defaultValue={client.fuel_charge} fullWidth error={inputErrors.fuel_charge} type="number" helperText={inputErrors.fuel_charge} placeholder="Fuel charge rate" label="Fuel Charge Rate" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="quotation" defaultValue={client.quotation} fullWidth error={inputErrors.pin} type="text" helperText={inputErrors.quotation} placeholder="Quotation" label="Quotation Number" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }} className="align_text">
                        <Button type="submit" variant="outlined" fullWidth onClick={validateInputs} color="secondary" sx={{ p: { xs: null, sm: 1.7 } }}>Save</Button>
                    </Grid>
                </Grid>
            </Collapse>

        </Box>
    );
}

export default TaxEdit;
